// extracted by mini-css-extract-plugin
export default {"header":"styles_header__kEYsP","logo":"styles_logo__gKEmv","empty":"styles_empty__iZ-4z"};